import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class ControlopService {
  private readonly baseUrl = `${API_BASE_URL}/controlop`;

  constructor(private http: HttpClient) {}

  getPermissions(tenantId: number, userId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId).set('user_id', userId);
    return this.http.get(`${this.baseUrl}/permissions`, { params });
  }

  getEmployeeExtras(tenantId: number, employeeId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/employees/${employeeId}/extras`, { params });
  }

  saveEmployeeExtras(tenantId: number, employeeId: number, payload: any): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.put(`${this.baseUrl}/employees/${employeeId}/extras`, payload, { params });
  }

  listActivities(tenantId: number, departmentId?: number): Observable<any> {
    let params = new HttpParams().set('tenant_id', tenantId);
    if (departmentId) {
      params = params.set('department_id', departmentId);
    }
    return this.http.get(`${this.baseUrl}/activities`, { params });
  }

  getActivity(tenantId: number, activityId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/activities/${activityId}`, { params });
  }

  createActivity(payload: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/activities`, payload);
  }

  updateActivity(activityId: number, payload: FormData): Observable<any> {
    return this.http.put(`${this.baseUrl}/activities/${activityId}`, payload);
  }

  deleteActivity(tenantId: number, activityId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.delete(`${this.baseUrl}/activities/${activityId}`, { params });
  }

  listForecasts(tenantId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/forecasts`, { params });
  }

  getForecast(tenantId: number, forecastId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/forecasts/${forecastId}`, { params });
  }

  createForecast(payload: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/forecasts`, payload);
  }

  updateForecast(forecastId: number, payload: FormData): Observable<any> {
    return this.http.put(`${this.baseUrl}/forecasts/${forecastId}`, payload);
  }

  listForecastHistory(tenantId: number, forecastId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/forecasts/${forecastId}/history`, { params });
  }

  listClosings(tenantId: number): Observable<any> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/closings`, { params });
  }

  createClosing(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/closings`, payload);
  }

  updateClosing(closingId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/closings/${closingId}`, payload);
  }
}
